<div class="md:@container" data-test-id="availability-widget">
	<div class="card flex flex-col gap-4 @md:flex-row">
		<div class="empty:hidden @md:hidden" data-test-id="slot">
			<ng-content />
		</div>
		<div class="flex size-full flex-col @md:flex-row children:flex-1">
			@if (showPackages() && packages()?.length > 0) {
				<vp-availability-widget-input-dropdown
					[className]="
						cn(
							'focus:relative focus:z-10',
							(this.showHotels() ||
								this.showOccupancy() ||
								this.showDates()) &&
								'@max-md:-mb-px @max-md:rounded-b-none @md:-mr-px @md:rounded-r-none max-md:-mb-px max-md:rounded-b-none'
						)
					"
					[items]="packages()"
					[label]="'global.package-label' | translate"
					[placeholder]="
						'global.package-selection-placeholder' | translate
					"
					[selectFirstItem]="true"
					[(isOpen)]="isPackagesOpen"
					(itemSelected)="onPackageSelect($event)"
					data-test-id="package-selector"
					inputName="availability-packages"
				/>
			}
			@if (showHotels() && hotels.length > 0) {
				<vp-availability-widget-input-dropdown
					[className]="
						cn(
							'focus:relative focus:z-10',
							this.showPackages() &&
								'@max-md:rounded-t-none @md:rounded-l-none max-md:rounded-t-none',
							(this.showOccupancy() || this.showDates()) &&
								'@max-md:-mb-px @max-md:rounded-b-none @md:-mr-px @md:rounded-r-none max-md:-mb-px max-md:rounded-b-none'
						)
					"
					[items]="hotels"
					[label]="'global.hotel' | translate"
					[placeholder]="
						'global.hotel-selection-placeholder' | translate
					"
					[(isOpen)]="isHotelsOpen"
					(itemSelected)="onHotelSelect($event)"
					data-test-id="hotels-selector"
					inputName="availability-hotels"
				/>
			}
			@if (showOccupancy() && occupancyRestrictions) {
				<vp-availability-widget-input-occupancy
					[className]="
						cn(
							'focus:relative focus:z-10',
							(this.showPackages() || this.showHotels()) &&
								'@max-md:rounded-t-none @md:rounded-l-none max-md:rounded-t-none',
							this.showDates() &&
								'@max-md:-mb-px @max-md:rounded-b-none @md:-mr-px @md:rounded-r-none max-md:-mb-px max-md:rounded-b-none'
						)
					"
					[defaultAdults]="defaultAdults"
					[initialOccupancy]="initialOccupancy"
					[isOpen]="isOccupancyOpen"
					[maxRooms]="occupancyRestrictions.maxOccupancies"
					[occupancyRestrictions]="occupancyRestrictions"
					(emitBackButton)="
						onBackButton(
							$event,
							showPackages(),
							showHotels(),
							false,
							false
						)
					"
					(emitChooseDates)="onChooseDatesEmit($event)"
					(emitIsPopoverOpen)="onOccupancyOpenEmit($event)"
					(occupancyChanged)="onOccupancyEmit($event)"
					data-test-id="occupancy-selector"
				/>
			}
			@if (showDates()) {
				<vp-availability-widget-input-date-range
					[availability]="availability$ | async"
					[className]="
						cn(
							'focus:md:border-l',
							(this.showPackages() ||
								this.showHotels() ||
								this.showOccupancy()) &&
								'@max-md:rounded-t-none @md:rounded-l-none max-md:rounded-t-none'
						)
					"
					[config]="{
						mode: 'range',
						showMonths: 2,
						minDate: minDate,
						maxDate: maxDate,
					}"
					[initialArrivalDate]="initialArrivalDate"
					[isLoading]="isLoading"
					[isOpen]="isDatePickerOpen"
					[jumpToFirstAvailableDate]="jumpToFirstAvailableDate"
					[numberOfNights]="
						showPackages() && this.selectedPackage?.nights
					"
					[resetDateRange]="_resetDateRange"
					(datePickerModelChanged)="updateModel($event)"
					(emitAvailabilityButton)="goToBookingtool()"
					(emitBackButton)="
						onBackButton(
							$event,
							showPackages(),
							showHotels(),
							showOccupancy(),
							false
						)
					"
					(emitIsPopoverOpen)="onDatePickerOpened($event)"
					(emitMonthChange)="onMonthChange($event)"
					(initialDatesNotAvailable)="
						recalculateAvailabilityForToday()
					"
					data-test-id="dates-selector"
				/>
			}
		</div>
		<button
			[disabled]="showHotels() && !selectedHotel"
			(click)="goToBookingtool()"
			class="btn btn-primary w-full @md:w-fit md:h-auto"
			data-test-id="cta-button"
		>
			{{ 'global.show-availability' | translate }}
		</button>
	</div>
</div>
